<template>
    <van-cell :title="title" :value="value" />
</template>
<script>
import { Cell } from 'vant';

export default {
    name: "EqCell",
    components: {
        "van-cell": Cell,
    },
    props: {
        title: {
            type: String,
            default: "text"
        },
        value: {
            type: String,
            default: "text"
        },
    },
    data() {
        return {
        };
    },
}
</script>